<template>
  <div class="mt-4">
    <div class="flex items-center justify-between mb-3">
      <h2 class="form-subtitle mb-0">Documentos generados</h2>
      <div>
        <input ref="editedInput" type="file" accept=".docx" class="hidden" style="display:none" @change="onEditedSelected" />
        <wz-button variant="primary" size="sm" @click="$refs.editedInput.click()">Subir versión modificada</wz-button>
      </div>
    </div>

    <table class="wz-table w-full">
      <thead>
        <tr>
          <th>Plantilla</th>
          <th>Tipo</th>
          <th>Generado por</th>
          <th>Fecha</th>
          <th class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="documents.length === 0">
          <td colspan="5" class="text-center text-muted">Sin documentos generados.</td>
        </tr>
        <tr v-for="d in documents" :key="d.id">
          <td>
            {{ d.templateNameSnapshot || '—' }}
            <wz-badge v-if="d.usedVariant" variant="success" pill class="ml-1">✨ Personalizada</wz-badge>
          </td>
          <td>
            {{ tipoLabel(d) }}
            <wz-badge v-if="d.id === latestGeneratedId" variant="success" pill class="ml-2">MÁS RECIENTE</wz-badge>
          </td>
          <td>{{ d.createdBy ? trimEmail(d.createdBy) : '—' }}</td>
          <td v-local-date:hour="d.createdAt"></td>
          <td class="text-right">
            <wz-button variant="outline" size="sm" @click="download(d)">Descargar</wz-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Alert, Util } from '@wizepe/wizeui'
import fileDownload from 'js-file-download'
import { ContractsService } from '@/core/services'

export default {
  name: 'ContractDocumentsSection',
  props: {
    contractId: { type: [Number, String], required: true },
  },
  data() {
    return { documents: [] }
  },
  computed: {
    // La lista viene ordenada por fecha DESC (backend). El badge lo lleva el PRIMER GENERADO (el más reciente).
    latestGeneratedId() {
      const first = this.documents.find(d => d.kind === 'CONTRATO_GENERADO')
      return first ? first.id : null
    },
  },
  created() {
    this.load()
  },
  methods: {
    trimEmail(val) {
      return Util.trimEmail(val)
    },
    // Etiqueta descriptiva del tipo de documento: distingue plantilla base vs. variante y versión modificada.
    tipoLabel(d) {
      if (d.kind === 'CONTRATO_GENERADO') {
        return d.usedVariant ? 'Generado con variante ✨' : 'Generado desde plantilla base'
      }
      if (d.kind === 'CONTRATO_EDITADO') return 'Versión modificada subida'
      return d.kind
    },
    async load() {
      try {
        const resp = await ContractsService.listDocuments(this.contractId)
        this.documents = resp.payload || []
      } catch (e) {
        Alert.error('Error al cargar los documentos')
      }
    },
    async download(d) {
      try {
        const resp = await ContractsService.downloadGeneratedDocument(this.contractId, d.id)
        fileDownload(resp.data, Util.getFileName(resp) || d.fileName)
      } catch (e) {
        Alert.error('Error al descargar')
      }
    },
    async onEditedSelected(event) {
      const file = event.target.files && event.target.files[0]
      event.target.value = ''
      if (!file) return
      if (!file.name.toLowerCase().endsWith('.docx')) {
        Alert.error('La versión modificada debe ser un archivo .docx')
        return
      }
      try {
        await ContractsService.uploadEditedDocument(this.contractId, file)
        Alert.success('Versión modificada subida')
        this.load()
      } catch (e) {
        Alert.error(e.errors ? e.errors.message : 'Error al subir la versión modificada')
      }
    },
  },
}
</script>

<style lang="stylus" scoped></style>
